<app-loader *ngIf="isLoading && !hasAuthError"></app-loader>

<!-- Access Denied UI -->
<div *ngIf="hasAuthError && !isLoading" class="access-denied-container">
  <div class="access-denied-card">
    <div class="access-denied-icon">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 7C13.1 7 14 7.9 14 9S13.1 11 12 11 10 10.1 10 9 10.9 7 12 7ZM12 17C10.34 17 8.93 16.16 8.15 14.9C8.69 13.96 10.23 13.5 12 13.5S15.31 13.96 15.85 14.9C15.07 16.16 13.66 17 12 17Z" fill="#dc3545"/>
      </svg>
    </div>
    <div class="access-denied-content">
      <h2 class="access-denied-title">Access Denied</h2>
      <p class="access-denied-message">
        You do not have sufficient permissions to access this application. 
        Please contact your system administrator for assistance.
      </p>
    </div>
  </div>
</div>

<ng-container #container *ngIf="!hasAuthError && !isLoading"></ng-container>